module.exports = __webpack_public_path__ + "static/media/foodvector.e25ad677.png";